import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(false);
  const [email, setEmail] = useState(null);
  const [openModel, setOpenModel] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [openLoginModel, setOpenLoginModel] = useState(false);
  const [addBothOnwardAndReturn, setAddBothOnwardAndReturn] = useState([]);
  const [returnRefId, setReturnRefId] = useState("");
  const [onwardRefID, setOnwardRefID] = useState("");
  const [serveType, setServeType] = useState(0);
  const [tripType, setTripType] = useState(0);

  return (
    <AuthContext.Provider
      value={{
        setUser,
        user,
        email,
        setEmail,
        setOpenModel,
        openModel,
        setWaiting,
        waiting,
        setOpenLoginModel,
        openLoginModel,
        setAddBothOnwardAndReturn,
        addBothOnwardAndReturn,
        setReturnRefId,
        returnRefId,
        setOnwardRefID,
        onwardRefID,
        setServeType,
        serveType,
        setTripType,
        tripType,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
